import './App.css';
import useScrollReveal from './hooks/useScrollReveal';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Footer from './components/Footer';

function App() {
  const dividerRef = useScrollReveal();

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <div className="soul-divider reveal" ref={dividerRef}>
        <p className="soul-quote mono">
          "Same principles on the pitch and in the codebase: discipline, teamwork, constant improvement."
        </p>
      </div>
      <Skills />
      <Projects />
      <Footer />
    </div>
  );
}

export default App;
